import { EditIcon } from "@chakra-ui/icons";
import {
  Button,
  Collapse,
  Flex,
  FormControl,
  FormLabel,
  Popover,
  PopoverAnchor,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Switch,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { useAtom } from "jotai";
import { atomWithStorage, createJSONStorage } from "jotai/utils";
import { hasFeature } from "../../features";

export const showCO2Atom = atomWithStorage("compareview.showCO2", false, createJSONStorage(() => sessionStorage));
export const showPricesAtom = atomWithStorage("compareview.showPrices", false, createJSONStorage(() => sessionStorage));
export const showTaxAtom = atomWithStorage("compareview.showTax", true, createJSONStorage(() => sessionStorage));
export const showCommentsAtom = atomWithStorage("compareview.showComments", false, createJSONStorage(() => sessionStorage));

const pricingEnabled = hasFeature("pricing");

export function ConfigureCompareViewModal() {
  const { isOpen, onClose, onToggle } = useDisclosure();

  const [showCO2, setShowCO2] = useAtom(showCO2Atom);
  const [showPrices, setShowPrices] = useAtom(showPricesAtom);
  const [showTax, setShowTax] = useAtom(showTaxAtom);
  const [showComments, setShowComments] = useAtom(showCommentsAtom);

  if (!pricingEnabled) return null;

  return (
    <Popover isOpen={isOpen} onClose={onClose} placement="bottom-end">
      <PopoverAnchor>
        <PopoverTrigger>
          <Button leftIcon={<EditIcon />} onClick={onToggle} variant="link">
            Overzicht aanpassen
          </Button>
        </PopoverTrigger>
      </PopoverAnchor>
      <PopoverContent borderRadius={8} w="sm">
        <PopoverArrow />
        <PopoverHeader
          alignItems="baseline"
          as={Flex}
          border="none"
          gap={4}
          pt={4}
          px={4}
        >
          Overzicht aanpassen
          <PopoverCloseButton color="gray.600" right={3} top={4} />
        </PopoverHeader>
        <PopoverBody>
          <VStack alignItems="flex-start" gap={2}>
            <FormControl alignItems="center" gap={2} w="auto">
              <FormLabel mb="0" size="md">
                <Switch
                  isChecked={showCO2}
                  onChange={(e) => setShowCO2(e.currentTarget.checked)}
                />{" "}
                Toon materiaalgebonden CO<sub>2</sub>-uitstoot
              </FormLabel>
            </FormControl>
            <FormControl alignItems="center" gap={2} w="auto">
              <FormLabel mb="0" size="md">
                <Switch
                  isChecked={showPrices}
                  onChange={(e) => setShowPrices(e.currentTarget.checked)}
                />{" "}
                Toon bedragen
              </FormLabel>
            </FormControl>
            <Collapse in={showPrices}>
              <FormControl alignItems="center" gap={2} w="auto">
                <FormLabel mb="0" size="md">
                  <Switch
                    isChecked={showTax}
                    onChange={(e) => setShowTax(e.currentTarget.checked)}
                  />{" "}
                  Toon bedragen inclusief BTW
                </FormLabel>{" "}
              </FormControl>
            </Collapse>
            <FormControl alignItems="center" gap={2} w="auto">
              <FormLabel mb="0" size="md">
                <Switch
                  isChecked={showComments}
                  onChange={(e) => setShowComments(e.currentTarget.checked)}
                />{" "}
                Toon opmerkingen
              </FormLabel>{" "}
            </FormControl>
          </VStack>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
